// extracted by mini-css-extract-plugin
export default {"box":"orderPage_box__+H1Sx"};